/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './baContentTop.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/theme/components/baContentTop/baContentTop.component';
import * as i5 from '../../../../../app/global.state';
import * as i6 from '@ngx-translate/core/src/translate.service';
const styles_BaContentTop:any[] = [i0.styles];
export const RenderType_BaContentTop:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_BaContentTop,
    data:{}});
export function View_BaContentTop_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),15,'div',[['class',
      'content-top clearfix']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),1,'h1',[['class','al-title']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),
      ['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n\n  '])),(_l()(),i1.ɵeld(5,0,
      (null as any),(null as any),9,'ul',[['class','breadcrumb al-breadcrumb']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵeld(7,0,(null as any),(null as any),3,
      'li',[['class','breadcrumb-item']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵeld(8,0,(null as any),(null as any),
      2,'a',[['routerLink','/pages/dashboard']],[[1,'target',0],[8,'href',4]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,9).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(9,671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['Home'])),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵeld(12,0,(null as any),(null as any),
      1,'li',[['class','breadcrumb-item active']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(13,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    const currVal_3:any = '/pages/dashboard';
    _ck(_v,9,0,currVal_3);
  },(_ck,_v) => {
    var _co:i4.BaContentTop = _v.component;
    const currVal_0:any = _co.activePageTitle;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = i1.ɵnov(_v,9).target;
    const currVal_2:any = i1.ɵnov(_v,9).href;
    _ck(_v,8,0,currVal_1,currVal_2);
    const currVal_4:any = _co.activePageTitle;
    _ck(_v,13,0,currVal_4);
  });
}
export function View_BaContentTop_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'ba-content-top',
      ([] as any[]),(null as any),(null as any),(null as any),View_BaContentTop_0,
      RenderType_BaContentTop)),i1.ɵdid(1,49152,(null as any),0,i4.BaContentTop,[i5.GlobalState,
      i6.TranslateService],(null as any),(null as any))],(null as any),(null as any));
}
export const BaContentTopNgFactory:i1.ComponentFactory<i4.BaContentTop> = i1.ɵccf('ba-content-top',
    i4.BaContentTop,View_BaContentTop_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvYmFDb250ZW50VG9wL2JhQ29udGVudFRvcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvYmFDb250ZW50VG9wL2JhQ29udGVudFRvcC5jb21wb25lbnQudHMiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvdGhlbWUvY29tcG9uZW50cy9iYUNvbnRlbnRUb3AvYmFDb250ZW50VG9wLmh0bWwiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvdGhlbWUvY29tcG9uZW50cy9iYUNvbnRlbnRUb3AvYmFDb250ZW50VG9wLmNvbXBvbmVudC50cy5CYUNvbnRlbnRUb3BfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiY29udGVudC10b3AgY2xlYXJmaXhcIj5cclxuICA8aDEgY2xhc3M9XCJhbC10aXRsZVwiPnt7IGFjdGl2ZVBhZ2VUaXRsZSB9fTwvaDE+XHJcblxyXG4gIDx1bCBjbGFzcz1cImJyZWFkY3J1bWIgYWwtYnJlYWRjcnVtYlwiPlxyXG4gICAgPGxpIGNsYXNzPVwiYnJlYWRjcnVtYi1pdGVtXCI+PGEgcm91dGVyTGluaz1cIi9wYWdlcy9kYXNoYm9hcmRcIj5Ib21lPC9hPjwvbGk+XHJcbiAgICA8bGkgY2xhc3M9XCJicmVhZGNydW1iLWl0ZW0gYWN0aXZlXCI+e3sgYWN0aXZlUGFnZVRpdGxlIH19PC9saT5cclxuICA8L3VsPlxyXG48L2Rpdj5cclxuIiwiPGJhLWNvbnRlbnQtdG9wPjwvYmEtY29udGVudC10b3A+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUEsZ0JBQWtDLDRDQUNoQztNQUFBO01BQUEsNENBQXFCO01BQUEsVUFBMEIsOENBRS9DO01BQUE7TUFBQSwwREFBcUM7TUFBQSwyQkFDbkM7TUFBQTtNQUFBLDhCQUE0QjtNQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7Y0FBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHVDQUFBO01BQUE7TUFBQSxlQUFpQyw0Q0FBYTtNQUFBLDJCQUMxRTtNQUFBO01BQUEsOEJBQW1DLDJDQUEwQjthQUFBLDZCQUMxRDtNQUNEO0lBSDZCO0lBQUgsV0FBRyxTQUFIOzs7SUFIVDtJQUFBO0lBR1M7SUFBQTtJQUFBLFdBQUEsbUJBQUE7SUFDTztJQUFBOzs7O29CQ0x2QztNQUFBOzZCQUFBLFVBQUE7eUJBQUE7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/components/baContentTop/baContentTop.component.ngfactory.ts